import Log from '../view/log'
import VideoAlarmOverView from '../view/VideoAlarm/OverView/OverView'
import PolicePointManagement from '../view/VideoAlarm/PolicePointManagement/PolicePointManagement'
import PolicePointManagementAdd from '../view/VideoAlarm/PolicePointManagement/PolicePointManagementAdd'
import PolicePointManagementModify from '../view/VideoAlarm/PolicePointManagement/PolicePointManagementModify'
import VideoAlarmStatistics from '../view/VideoAlarm/VideoAlarmStatistics/VideoAlarmStatistics'
import VideoAlarmRecord from '../view/VideoAlarm/VideoAlarmRecord/VideoAlarmRecord'
import VideoAlarmNav from '../view/VideoAlarm/VideoAlarmNav'

export default [
  {
    path: '/video_alarm_over_view',
    name: 'video-alarm-over-view',
    components: {
      default: VideoAlarmNav,
      a: VideoAlarmOverView,
    },
  },
  {
    path: '/police_point_management',
    name: 'police-point-management',
    components: {
      default: VideoAlarmNav,
      a: PolicePointManagement,
    },
  },
  {
    path: '/police_point_management_add',
    name: 'police-point-management-add',
    components: {
      default: VideoAlarmNav,
      a: PolicePointManagementAdd,
    },
  },
  {
    path: '/police_point_management_modify/:id',
    name: 'police-point-management-modify',
    components: {
      default: VideoAlarmNav,
      a: PolicePointManagementModify,
    },
  },
  {
    path: '/video_alarm_statistics',
    name: 'video-alarm-statistics',
    components: {
      default: VideoAlarmNav,
      a: VideoAlarmStatistics,
    },
  },
  {
    path: '/video_alarm_record',
    name: 'video-alarm-record',
    components: {
      default: VideoAlarmNav,
      a: VideoAlarmRecord,
    },
  },
  {
    path: '/video_log',
    name: 'video-log',
    components: {
      default: VideoAlarmNav,
      a: Log,
    },
  },
]



// WEBPACK FOOTER //
// ./src/router/VideoAlarm.js